import {EntityLogoRequestParams} from "../../../infrastructure/models/params/entity-logo-request-params";
import {SportViewModel} from "./sport-view-model";
import {IMAGE_DEFAULT_FORMATS} from "../../../core/app/consts";

export class SportPossessionLogoPrams extends EntityLogoRequestParams {
  constructor(params: SportPossessionLogoPrams, entity: SportViewModel) {
    super({...params, resourceName: 'Website/SportTypes/PossessionIcon'}, entity);

    this.isRound = false;
    this.fallbackResourceName = 'default1';
    this.pngName = this.id;
  }

  get defaultFormat(): String {
    return IMAGE_DEFAULT_FORMATS.SVG;
  }
}
